import CommissionLayout from '@/layouts/CommissionLayout.vue'
import TimeOffRequestLayout from '@/layouts/TimeOffRequestLayout.vue'
import TimeTrackingLayout from '@/layouts/TimeTrackingLayout.vue'

export const PAYROLL_ROUTES = [
  {
    path: '/payroll-runs',
    name: 'PayrollRunList',
    component: () => import('./payrollRuns/views/PayrollRunList.vue'),
  },
  {
    path: '/payroll-runs/preview',
    name: 'PayrollRunPreview',
    component: () => import('./payrollRuns/views/PayrollRunPreview.vue'),
  },
  {
    path: '/payroll-runs/:id',
    name: 'PayrollRunDisplay',
    component: () => import('./payrollRuns/views/PayrollRunDisplay.vue'),
  },

  {
    path: '/admin-time-off-requests',
    component: TimeOffRequestLayout,
    redirect: { name: 'AdminTimeOff' },
    children: [
      {
        path: '',
        name: 'AdminTimeOff',
        component: () => import('./timeOffRequests/views/AdminTimeOff.vue'),
      },
      {
        path: 'list',
        name: 'AdminTimeOffList',
        component: () => import('./timeOffRequests/views/AdminTimeOffList.vue'),
      },
    ],
  },
  {
    path: '/admin-time-tracking',
    component: TimeTrackingLayout,
    redirect: { name: 'AdminTimeTracking' },
    children: [
      {
        path: '',
        name: 'AdminTimeTracking',
        component: () => import('./timeTracking/views/AdminTimeTracking.vue'),
      },
      {
        path: 'list',
        name: 'AdminTimeTrackingList',
        component: () => import('./timeTracking/views/AdminTimeTrackingList.vue'),
      },
    ],
  },
  {
    path: '/admin-commissions',
    component: CommissionLayout,
    redirect: { name: 'AdminCommissions' },
    children: [
      {
        path: 'pending',
        name: 'AdminCommissions',
        component: () => import('./commissions/views/AdminCommissions.vue'),
      },
      {
        path: 'list',
        name: 'AdminCommissionsList',
        component: () => import('./commissions/views/AdminCommissionsList.vue'),
      },
    ],
  },
  {
    path: '/time-off-requests/create',
    name: 'AdminCreateTimeOffRequest',
    component: () => import('./timeOffRequests/views/CreateTimeOffRequest.vue'),
  },
  {
    path: '/time-off-requests/:id/edit',
    name: 'AdminEditTimeOffRequest',
    component: () => import('./timeOffRequests/views/EditTimeOffRequest.vue'),
  },
  {
    path: '/member-time-off',
    name: 'MemberTimeOff',
    component: () => import('./timeOffRequests/views/MemberTimeOff.vue'),
  },
  {
    path: '/member-commissions',
    name: 'MemberCommissions',
    component: () => import('./commissions/views/MemberCommissions.vue'),
  },
  {
    path: '/member-paystubs',
    name: 'MemberPaystubs',
    component: () => import('./payrollRuns/views/MemberPaystubs.vue'),
  },
  {
    path: '/time-tracking-entries/:id/edit',
    name: 'EditTimeTrackingEntry',
    component: () => import('./timeTracking/views/EditTimeTrackingEntry.vue'),
  },
  {
    path: '/time-tracking-entries/create',
    name: 'CreateTimeTrackingEntry',
    component: () => import('./timeTracking/views/CreateTimeTrackingEntry.vue'),
  },
]

export const FIELD_PAYROLL_ROUTES = [
  {
    path: 'time-tracking',
    name: 'FieldTimeTracking',
    component: () => import('./timeTracking/views/FieldTimeTracking.vue'),
  },
  {
    path: 'paystubs',
    name: 'FieldPaystubs',
    component: () => import('./payrollRuns/views/MemberPaystubs.vue'),
  },
  {
    path: 'time-off',
    name: 'FieldTimeOff',
    component: () => import('./timeOffRequests/views/MemberTimeOff.vue'),
  },
  {
    path: 'time-off-requests/create',
    name: 'MemberCreateTimeOffRequest',
    component: () => import('./timeOffRequests/views/CreateTimeOffRequest.vue'),
  },
  {
    path: 'time-off-requests/:id/edit',
    name: 'MemberEditTimeOffRequest',
    component: () => import('./timeOffRequests/views/EditTimeOffRequest.vue'),
  },
]

export const COMMISSION_PLAN_ROUTES = [
  {
    path: 'commission-plans',
    name: 'CommissionPlanList',
    component: () => import('./commissionPlans/views/CommissionPlanList.vue'),
  },
  {
    path: 'commission-plans/create',
    name: 'CreateCommissionPlan',
    component: () => import('./commissionPlans/views/CreateCommissionPlan.vue'),
  },
  {
    path: 'commission-plans/:id/edit',
    name: 'EditCommissionPlan',
    component: () => import('./commissionPlans/views/EditCommissionPlan.vue'),
  },
]
